/* Nomaï — calculateur de billes EPS (sections/nomai-calculateur-billes.liquid). Sans dépendance.
   Seule source des formules : volume de la housse en cm³, puis coefficient de remplissage (article du Journal). */
(() => {
  const FORMES = {
    rond:   { champs: ['d', 'h'],      volume: (v) => (Math.PI / 4) * v.d * v.d * v.h },
    pave:   { champs: ['l', 'w', 'h'], volume: (v) => v.l * v.w * v.h },
    poire:  { champs: ['d', 'h'],      volume: (v) => (Math.PI / 12) * v.h * v.d * v.d * (1 + 0.35 + 0.35 * 0.35) },
    souple: { champs: ['l', 'w', 'h'], volume: (v) => (Math.PI / 6) * v.l * v.w * v.h }
  };
  const COEF = { souple: 0.7, equilibre: 0.78, ferme: 0.85 };
  const RECHARGE = [0.1, 0.2]; // part de la quantité cible à reverser après tassement
  const MIN = 10, MAX = 300;
  const arrondi = (n, pas) => Math.round(n / pas) * pas;
  const fr = (n) => n.toLocaleString('fr-FR');

  const brancher = (racine) => {
    const form = racine.querySelector('form');
    const sorties = {};
    racine.querySelectorAll('[data-sortie]').forEach((el) => { sorties[el.dataset.sortie] = el; });
    const conditionnels = racine.querySelectorAll('[data-formes]');

    const calculer = () => {
      const forme = form.elements.forme.value;
      conditionnels.forEach((el) => { el.hidden = !el.dataset.formes.split(' ').includes(forme); });

      const def = FORMES[forme], v = {};
      const valide = def.champs.every((c) => {
        v[c] = form.elements[c].valueAsNumber;
        return v[c] >= MIN && v[c] <= MAX;
      });
      racine.classList.toggle('is-invalide', !valide);
      sorties.erreur.hidden = valide;
      if (!valide) return; // on garde le dernier résultat, grisé par .is-invalide

      const housse = def.volume(v) / 1000;
      const cible = housse * COEF[form.elements.fermete.value];
      sorties.litres.textContent = fr(arrondi(cible, 5));
      sorties.min.textContent = fr(arrondi(housse * COEF.souple, 5));
      sorties.max.textContent = fr(arrondi(housse * COEF.ferme, 5));
      sorties.recharge.textContent = `${fr(arrondi(cible * RECHARGE[0], 5))} à ${fr(arrondi(cible * RECHARGE[1], 5))}`;
      sorties.housse.textContent = fr(Math.round(housse));
    };

    form.addEventListener('input', calculer);
    form.addEventListener('submit', (e) => e.preventDefault());
    calculer();
  };

  document.querySelectorAll('[data-nm-calc]').forEach(brancher);
})();
